import logo from '../assets/based.svg'

export const Logo = () => {
  return (
    <img
      style={{
        height: '40px',
        width: 'auto',
      }}
      alt="Based.io"
      src={logo}
    />
  )
}
